import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../lib/redux/hooks'
import { GetFileObjectById, resetGetFileObjectByIdStatus } from '../../../../objectStorage/slice'
import { ButtonComponent } from '../../../../ui/molecules/button/newButton'
import { Calendar } from '../../../../ui/molecules/calendar'
import CheckboxGroup from '../../../../ui/molecules/CheckBoxGroup'
import InputMultiSearch from '../../../../ui/molecules/input/InputMultiSearch'
import { MadfarmInput } from '../../../../ui/molecules/input/newInput'
import { ProtocolSearch } from '../../../../ui/molecules/ProtocolSearch'
import { MadfarmStaticSelect } from '../../../../ui/molecules/select/newSelect/static'
import { SingleCheckbox } from '../../../../ui/molecules/SingleCheckbox'
import TextArea from '../../../../ui/molecules/textArea'
import { PopupForm } from '../../../../ui/organisms/popupForm'
import { countries, DestinationOfficesType, entryMeansOptions, formatterDate, OptionType, regioniList } from '../../../../utils'
import { GetCustomerByCompanyNameResponseDTO, getCustomersByIdResponseDTO } from '../../../clienti/dto'
import { GetCustomersByCompanyName, GetCustomersById } from '../../../clienti/slice'
import { resetfindMeStatusIdle } from '../../../users/slice'
import { AddObjectPopupEntry } from '../../popup/addObjectEntry'
import '../../styles.scss'
import { EntryProtocolCreation, EntryProtocolUpdate, EntryProtocolUploadAttachmentFile, GetAllEntryProtocolObjects, GetEntryProtocolById, resetEntryProtocolErrors, resetEntryProtocolUpdateStatus, resetEntryProtocolUploadAttachmentFileStatus, resetEntryProtocolValidationStatus, resetEPObjCreationRequest, resetGetAllEntryProtocolObjectsStatus, resetGetEntryProtocolByIdStatus, setEntryProtocolIdToUpdate, setEPCustomerIds, setEPCustomersNotRegistered, setEPDestinationOffice, setEPEntryChannel, setEPEntryObjectId, setEPFileAndAtt, setEPHeadquarter, setEPLinkExistingProtocol, setEPNation, setEPObjectSpec, setEPProtocolDate, setEPRegion, setEPSend, setEPSender, setEPTotalPage, setEPUserId, setEPUsersVisibility, setFileToUpdate, setFromCreationToUpdate, setUpdatedEPFileAndAtt, setUpdatedFile, setUpdateEPCustomerIds, setUpdateEPCustomersNotRegistered, setUpdateEPDestinationOffice, setUpdateEPEntryAttachmentIds, setUpdateEPEntryChannel, setUpdateEPEntryObjectId, setUpdateEPHeadquarter, setUpdateEPLinkExistingProtocol, setUpdateEPNation, setUpdateEPObjectSpec, setUpdateEPRegion, setUpdateEPSend, setUpdateEPSender, setUpdateEPTotalPage, setUpdateEPUsersVisibility, setValidateProtocolDate, setValidateSend } from '../slice'

type CustomerSearchItem = GetCustomerByCompanyNameResponseDTO | getCustomersByIdResponseDTO

export function NewEntryLeft() {
    const dispatch = useAppDispatch()
    const entryProtocolState = useAppSelector(state => state.entryProtocol)
    const objectStorageState = useAppSelector(state => state.objectStorage)
    const userState = useAppSelector(state => state.users)
    const [viewable, setViewable] = useState<boolean>(false)
    const [selectedOffices, setSelectedOffices] = useState<DestinationOfficesType[]>([])
    const [objects, setObjects] = useState<OptionType[]>([])
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const [file, setFile] = useState<File | null>(null)
    const [officeSot, setOfficeSot] = useState<OptionType[]>([])

    let formData = new FormData();
    let attachmentFormData = new FormData();

    const searchCustomers = async (query: string): Promise<CustomerSearchItem[]> => {
        const response = await dispatch(GetCustomersByCompanyName(query)).unwrap()
        return (response?.data ?? []) as CustomerSearchItem[]
    }

    const fetchCustomerById = async (id: string): Promise<CustomerSearchItem> => {
        const result = await dispatch(GetCustomersById(id)).unwrap()
        return result as CustomerSearchItem
    }

    const handleTypesChange = (value: DestinationOfficesType) => {
        let currentOffices = [...selectedOffices]
        if (currentOffices.includes(value)) {
            currentOffices = currentOffices.filter(t => t !== value)
        }
        else {
            currentOffices.push(value)
        }
        setSelectedOffices(currentOffices)

        !entryProtocolState.fromCreationToUpdate ?
            dispatch(setEPDestinationOffice(currentOffices)) :
            dispatch(setUpdateEPDestinationOffice(currentOffices))
    }

    useEffect(() => {
        if (userState.findMeStatus === 'successfully') {
            if (userState.findMeResponse.headQuarterInfo !== null && userState.findMeResponse.headQuarterInfo !== undefined) {
                const newOption: OptionType = {
                    value: userState.findMeResponse.headQuarterInfo.code,
                    label: userState.findMeResponse.headQuarterInfo.code
                };
                setOfficeSot(prevOptions => {
                    const optionExists = prevOptions.some(option => option.value === newOption.value);
                    if (!optionExists) {
                        return [...prevOptions, newOption];
                    }
                    return prevOptions;
                });
            }
            dispatch(resetfindMeStatusIdle())

        }
    }, [userState.findMeStatus])

    useEffect(() => {
        setFile(entryProtocolState.fileToUpdate as File)
    }, [entryProtocolState.fileToUpdate])

    useEffect(() => {
        if (entryProtocolState.entryProtocolValidationStatus === 'successfully') {
            dispatch(resetEntryProtocolValidationStatus())
            if (!entryProtocolState.fromCreationToUpdate)
                dispatch(EntryProtocolCreation(entryProtocolState.entryProtocolCreationRequest))
            else {
                formData.delete('file')
                if (file !== null)
                    formData.append('file', file)
                formData.append('entryProtocolUpdateDTO', JSON.stringify(entryProtocolState.entryProtocolUpdateRequest))
                dispatch(EntryProtocolUpdate({ body: formData, id: entryProtocolState.entryProtocolIdToUpdate }))
            }
        }
    }, [entryProtocolState.entryProtocolValidationStatus])

    useEffect(() => {
        setFile(null)
        dispatch(setEPUserId(userState.loggedUserId))
        dispatch(setFromCreationToUpdate(false))
        dispatch(resetEntryProtocolErrors())
        dispatch(GetAllEntryProtocolObjects())
    }, [])

    useEffect(() => {
        if (entryProtocolState.getAllEntryProtocolObjectsStatus === 'successfully' &&
            entryProtocolState.getAllEntryProtocolObjectsResponse !== undefined
        ) {
            dispatch(resetGetAllEntryProtocolObjectsStatus())
            const data = entryProtocolState.getAllEntryProtocolObjectsResponse
            const newObjects: OptionType[] = data.map(d => {
                return { value: d.id, label: `${d.description} [${d.coding}]` } as OptionType
            })
            setObjects(newObjects)
        }
    }, [entryProtocolState.getAllEntryProtocolObjectsStatus])

    useEffect(() => {
        !entryProtocolState.fromCreationToUpdate ?
            dispatch(setEPUsersVisibility(viewable)) :
            dispatch(setUpdateEPUsersVisibility(viewable))
    }, [viewable])

    useEffect(() => {
        if (entryProtocolState.getEntryProtocolByIdStatus === 'successfully' &&
            entryProtocolState.getEntryProtocolByIdResponse !== undefined
        ) {
            dispatch(resetGetEntryProtocolByIdStatus())
            dispatch(setFromCreationToUpdate(true))
            const data = entryProtocolState.getEntryProtocolByIdResponse
            dispatch(setEntryProtocolIdToUpdate(data.id))
            dispatch(setUpdateEPHeadquarter(data.headQuarter))
            dispatch(setUpdateEPNation(data.nation))
            dispatch(setUpdateEPRegion(data.region))
            dispatch(setUpdateEPSender(data.sender))
            if (data.customersInfo !== null)
                dispatch(setUpdateEPCustomerIds(data.customersInfo.map(c => c.id)))
            dispatch(setUpdateEPCustomersNotRegistered(data.customersNotRegistered))
            dispatch(setUpdateEPEntryObjectId(data.entryObject.id))
            dispatch(setUpdateEPObjectSpec(data.objectSpec))
            dispatch(setUpdateEPTotalPage(data.totalPage))
            dispatch(setUpdateEPEntryChannel(data.entryChannel))
            dispatch(setUpdateEPSend(data.send))
            dispatch(setUpdateEPUsersVisibility(data.usersVisibility))
            setViewable(data.usersVisibility!)
            dispatch(setUpdateEPLinkExistingProtocol(data.linkExistingProtocol))
            dispatch(setUpdateEPDestinationOffice(data.destinationOffice))
            setSelectedOffices(data.destinationOffice as DestinationOfficesType[])
            dispatch(setUpdateEPEntryAttachmentIds(data.entryAttachments.map(a => a.id)))
            dispatch(setUpdatedEPFileAndAtt(data.attachmentFile))
        }
    }, [entryProtocolState.getEntryProtocolByIdStatus])

    useEffect(() => {
        if (entryProtocolState.entryProtocolUpdateStatus === 'successfully' &&
            entryProtocolState.entryProtocolUpdateResponse !== undefined
        ) {
            dispatch(resetEntryProtocolUpdateStatus())
            dispatch(setFileToUpdate(null))
            if (entryProtocolState.entryProtocolUpdateResponse !== null &&
                entryProtocolState.entryProtocolUpdateResponse !== '' &&
                entryProtocolState.entryProtocolUpdateResponse) {
                dispatch(GetFileObjectById(entryProtocolState.entryProtocolUpdateResponse))
            }

            if (entryProtocolState.entryProtocolUpdateFileAndAtt.length > 0) {
                const attF = entryProtocolState.entryProtocolUpdateFileAndAtt[0]
                dispatch(setEPFileAndAtt(entryProtocolState.entryProtocolUpdateFileAndAtt.slice(1)))
                if (attF !== undefined && attF && attF !== null) {
                    if (attF.file !== undefined && attF.file) {
                        attachmentFormData.delete('file')
                        attachmentFormData.append('file', attF.file)
                        attachmentFormData.append('attachmentFileDTO', JSON.stringify({ attachmentId: attF.attachmentId }))
                        dispatch(EntryProtocolUploadAttachmentFile({ data: attachmentFormData, id: entryProtocolState.entryProtocolIdToUpdate }))
                    }
                }
            }
        }
    }, [entryProtocolState.entryProtocolUpdateStatus])

    useEffect(() => {
        if (entryProtocolState.entryProtocolUploadAttachmentFileStatus === 'successfully') {
            dispatch(resetEntryProtocolUploadAttachmentFileStatus())
            if (entryProtocolState.entryProtocolUpdateFileAndAtt.length > 0) {
                const attF = entryProtocolState.entryProtocolUpdateFileAndAtt[0]
                dispatch(setEPFileAndAtt(entryProtocolState.entryProtocolUpdateFileAndAtt.slice(1)))

                if (attF !== undefined && attF && attF !== null) {
                    if (attF.file !== undefined && attF.file) {
                        attachmentFormData.delete('file')
                        attachmentFormData.append('file', attF.file)
                        attachmentFormData.append('attachmentFileDTO', JSON.stringify({ attachmentId: attF.attachmentId }))
                        dispatch(EntryProtocolUploadAttachmentFile({ data: attachmentFormData, id: entryProtocolState.entryProtocolIdToUpdate }))
                    }
                }
            }
            else {
                dispatch(GetEntryProtocolById(entryProtocolState.entryProtocolIdToUpdate))
            }
        }
    }, [entryProtocolState.entryProtocolUploadAttachmentFileStatus])

    useEffect(() => {
        if (objectStorageState.getFileObjectByIdStatus === 'successfully' &&
            objectStorageState.getFileObjectByIdResponse !== undefined
        ) {
            dispatch(resetGetFileObjectByIdStatus())
            dispatch(setUpdatedFile(objectStorageState.getFileObjectByIdResponse))
        }
    }, [objectStorageState.getFileObjectByIdStatus])

    return (
        <div className='pb-6'>
            <div className="protocol-header">
                <span className='title'>Nuovo protocollo</span>
            </div>
            <div className='protocol-content flex flex-col gap-6'>
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmStaticSelect
                        required
                        label="Protocollo"
                        error={entryProtocolState.entryProtocolErrors.headQuarter}
                        errorLabel='Sede mancante'
                        placeholder={'Seleziona protocollo'}
                        options={officeSot}
                        onChange={(value) => {
                            //@ts-ignore 
                            const newValue = value ? value.value : null
                            dispatch(setEPHeadquarter(newValue))
                        }}
                        disabled={entryProtocolState.fromCreationToUpdate}
                        defaultValue={entryProtocolState.entryProtocolCreationRequest.headQuarter}
                        value={entryProtocolState.entryProtocolCreationRequest.headQuarter}
                        noOptionsMessage={'Nessun protoccolo trovato'}
                    />
                    <Calendar
                        required
                        placeholder='Seleziona data'
                        label="Data protocollo"
                        errorLabel={entryProtocolState.entryProtocolErrors.protocolDate ? 'Data mancante' : undefined}
                        disabled={entryProtocolState.fromCreationToUpdate}
                        selected={entryProtocolState.entryProtocolCreationRequest.protocolDate === null ? undefined : entryProtocolState.entryProtocolCreationRequest.protocolDate}
                        onChange={(date) => {
                            dispatch(setEPProtocolDate(date))
                            dispatch(setValidateProtocolDate(false))
                        }}
                    />
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmStaticSelect
                        label="Nazione"
                        placeholder={'Seleziona nazione'}
                        options={countries}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            !entryProtocolState.fromCreationToUpdate ?
                                dispatch(setEPNation(newValue)) :
                                dispatch(setUpdateEPNation(newValue))
                        }}
                        value={!entryProtocolState.fromCreationToUpdate ?
                            (entryProtocolState.entryProtocolCreationRequest.nation ? entryProtocolState.entryProtocolCreationRequest.nation : 'IT') :
                            (entryProtocolState.entryProtocolUpdateRequest.nation ? entryProtocolState.entryProtocolUpdateRequest.nation : 'IT')
                        }
                        noOptionsMessage={'Nessuna nazione trovata'}
                    />
                    <MadfarmStaticSelect
                        required
                        label="Regione"
                        error={entryProtocolState.entryProtocolErrors.region}
                        errorLabel='Regione mancante'
                        placeholder={'Seleziona regione'}
                        options={regioniList}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            !entryProtocolState.fromCreationToUpdate ?
                                dispatch(setEPRegion(newValue)) :
                                dispatch(setUpdateEPRegion(newValue))
                        }}
                        value={!entryProtocolState.fromCreationToUpdate ?
                            entryProtocolState.entryProtocolCreationRequest.region :
                            entryProtocolState.entryProtocolUpdateRequest.region
                        }
                        noOptionsMessage="Nessuna regione trovata"
                    />
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmInput
                        required
                        error={entryProtocolState.entryProtocolErrors.sender}
                        supportingText={entryProtocolState.entryProtocolErrors.sender ? 'Mittente mancante' : undefined}
                        label={'Mittente'}
                        placeholder="Mittente dei documenti da protocollare"
                        value={!entryProtocolState.fromCreationToUpdate ?
                            entryProtocolState.entryProtocolCreationRequest.sender :
                            entryProtocolState.entryProtocolUpdateRequest.sender
                        }
                        onChangeText={(text) => !entryProtocolState.fromCreationToUpdate ?
                            dispatch(setEPSender(text)) :
                            dispatch(setUpdateEPSender(text))
                        }
                    />
                    <InputMultiSearch
                        onSearch={searchCustomers}
                        onFetchById={fetchCustomerById}
                        getId={(customer) => customer.id}
                        renderResult={(customer, isSelected) => {
                            const isInactive = customer.endingDate !== null
                            return (
                                <div className="flex flex-col gap-0.5 items-start">
                                    <span
                                        className={clsx('font-semibold text-left', {
                                            'text-red-600': isInactive && !isSelected,
                                            'text-brandPrimary-700': !isInactive && !isSelected,
                                        })}
                                    >
                                        {customer.companyName}
                                    </span>
                                    <span className="text-xs text-neutral-600 text-left">
                                        {customer.countryRegion} - {customer.cuaa} - {customer.clientCode}
                                    </span>
                                    <span className="text-xs text-neutral-500 text-left">
                                        Data In: {formatterDate(customer.startingDate)} | Data Out: {customer.endingDate ? formatterDate(customer.endingDate) : '-'}
                                    </span>
                                </div>
                            )
                        }}
                        renderSelected={(customer) => (
                            <div className="flex flex-col gap-0.5 flex-1 items-start">
                                <span className="text-sm font-bold text-brandPrimary-700 text-left">
                                    {customer.companyName}
                                </span>
                                <span className="text-xs text-brandPrimary-600 text-left">
                                    {customer.countryRegion} - {customer.cuaa} - {customer.clientCode}
                                </span>
                                <span className="text-xs text-brandPrimary-600 text-left">
                                    Data In: {formatterDate(customer.startingDate)} | Data Out: {customer.endingDate ? formatterDate(customer.endingDate) : '-'}
                                </span>
                            </div>
                        )}
                        defaultIds={!entryProtocolState.fromCreationToUpdate ?
                            entryProtocolState.entryProtocolCreationRequest.customerIds :
                            entryProtocolState.entryProtocolUpdateRequest.customerIds
                        }
                        label={'Cliente'}
                        placeholder="Ragione sociale"
                        onSelectAddHandler={(res) => !entryProtocolState.fromCreationToUpdate ?
                            dispatch(setEPCustomerIds(res)) :
                            dispatch(setUpdateEPCustomerIds(res))
                        }
                    />
                </div>
                <div className='grid grid-cols'>
                    <MadfarmInput
                        label={'Cliente non presente in archivio'}
                        placeholder="Indicare nel caso di cliente non ancora inserito in archivio"
                        value={!entryProtocolState.fromCreationToUpdate ?
                            entryProtocolState.entryProtocolCreationRequest.customersNotRegistered :
                            entryProtocolState.entryProtocolUpdateRequest.customersNotRegistered
                        }
                        onChangeText={(text) => !entryProtocolState.fromCreationToUpdate ?
                            dispatch(setEPCustomersNotRegistered(text)) :
                            dispatch(setUpdateEPCustomersNotRegistered(text))
                        }
                    />
                </div>
                <div className='flex flex-row items-center gap-4'>
                    <div className={clsx("w-full", { "w-[85%]": userState.findMeResponse.role === "admin" })}>
                        <MadfarmStaticSelect
                            required
                            label="Oggetto (Da elenco)"
                            error={entryProtocolState.entryProtocolErrors.entryObjectId}
                            errorLabel='Oggetto mancante'
                            placeholder={'Seleziona...'}
                            options={objects}
                            value={!entryProtocolState.fromCreationToUpdate ?
                                entryProtocolState.entryProtocolCreationRequest.entryObjectId :
                                entryProtocolState.entryProtocolUpdateRequest.entryObjectId}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value ? value.value : null
                                !entryProtocolState.fromCreationToUpdate ?
                                    dispatch(setEPEntryObjectId(newValue)) :
                                    dispatch(setUpdateEPEntryObjectId(newValue))
                            }}
                            noOptionsMessage={'Nessun oggetto trovato'}
                        />
                    </div>
                    {
                        userState.findMeResponse.role === 'admin' &&
                        <div className="w-[15%] pt-5">
                            <ButtonComponent
                                variant='outline'
                                color='orange'
                                size='md'
                                iconPosition='off'
                                label='Crea oggetto'
                                onClick={() => setShowPopup(true)}
                                fullWidth
                            />
                        </div>
                    }
                </div>
                <div className='grid grid-cols'>
                    <TextArea
                        label="Specifiche oggetto"
                        placeholder="Integrazione all'oggetto indicato sopra"
                        onChangeText={(text) => !entryProtocolState.fromCreationToUpdate ?
                            dispatch(setEPObjectSpec(text)) :
                            dispatch(setUpdateEPObjectSpec(text))
                        }
                    />
                </div>
                <div className="border h-[1px] border-neutral-200" />
                <div className='grid grid-cols-3 gap-4'>
                    <MadfarmInput
                        required
                        error={entryProtocolState.entryProtocolErrors.totalPage}
                        supportingText={entryProtocolState.entryProtocolErrors.totalPage ? 'Totale pagine mancante' : undefined}
                        label={'Totale pagine'}
                        placeholder="Specificare numero"
                        value={!entryProtocolState.fromCreationToUpdate ?
                            entryProtocolState.entryProtocolCreationRequest.totalPage?.toString()! :
                            entryProtocolState.entryProtocolUpdateRequest.totalPage?.toString()
                        }
                        onChangeText={(text) => !entryProtocolState.fromCreationToUpdate ?
                            dispatch(setEPTotalPage(Number(text))) :
                            dispatch(setUpdateEPTotalPage(Number(text)))
                        }
                    />
                    <MadfarmStaticSelect
                        required
                        isClearable
                        noOptionsMessage="Nessun risultato trovato"
                        label="Mezzo entrata"
                        error={entryProtocolState.entryProtocolErrors.entryChannel}
                        errorLabel='Mezzo mancante'
                        placeholder={'Seleziona...'}
                        options={entryMeansOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            !entryProtocolState.fromCreationToUpdate ?
                                dispatch(setEPEntryChannel(newValue)) :
                                dispatch(setUpdateEPEntryChannel(newValue))
                        }}
                        value={!entryProtocolState.fromCreationToUpdate ?
                            entryProtocolState.entryProtocolCreationRequest.entryChannel :
                            entryProtocolState.entryProtocolUpdateRequest.entryChannel
                        }
                    />
                    <Calendar
                        required
                        placeholder='Seleziona data'
                        label="Data Spedizione/Invio"
                        errorLabel={entryProtocolState.entryProtocolErrors.send ? 'Data mancante' : undefined}
                        selected={!entryProtocolState.fromCreationToUpdate ?
                            entryProtocolState.entryProtocolCreationRequest.send === null ? undefined : entryProtocolState.entryProtocolCreationRequest.send :
                            entryProtocolState.entryProtocolUpdateRequest.send
                        }
                        onChange={(date) => {
                            if (!entryProtocolState.fromCreationToUpdate) {
                                dispatch(setEPSend(date))
                            } else {
                                dispatch(setUpdateEPSend(date))
                            }
                            dispatch(setValidateSend(false))
                        }}
                    />
                </div>
                <SingleCheckbox
                    checked={viewable}
                    setChecked={setViewable}
                    label='Protocollo visualizzabile da tutti gli utenti'
                />
                <div className="border h-[1px] border-neutral-200" />
                <span className="input-label" style={{ fontSize: '18px', fontWeight: 600 }}>
                    Aggancia a protocollo esistente
                </span>
                <ProtocolSearch
                    type='entry'
                    onSelect={(value) => !entryProtocolState.fromCreationToUpdate ?
                        dispatch(setEPLinkExistingProtocol(value)) :
                        dispatch(setUpdateEPLinkExistingProtocol(value))
                    }
                />
                <div className="border h-[1px] border-neutral-200" />
                <span className="input-label" style={{ fontSize: '18px', fontWeight: 600 }}>
                    Uffici di destinazione
                    <span className='text-red-600'> *</span>
                </span>
                {
                    entryProtocolState.entryProtocolErrors.destinationOffice &&
                    <span className="text-sm font-semibold text-red-500">Indica almeno un ufficio di destinazione</span>
                }
                <div className='grid grid-cols-3 gap-4'>
                    <CheckboxGroup
                        name="tipo_ufficio_1"
                        options={Object.values(DestinationOfficesType).splice(0, 4)}
                        selectedValues={selectedOffices}
                        onChange={handleTypesChange}
                        optionLabels={{
                            [DestinationOfficesType.DIREZIONE]: "Direzione",
                            [DestinationOfficesType.MON_PEC_DIREZIONE]: "Monitoraggio PEC Direzione",
                            [DestinationOfficesType.AMM_UNICO]: "Amministratore Unico (Fasano)",
                            [DestinationOfficesType.SCHEME_MANAGER_GG]: "Scheme Manager GG"
                        }}
                    />
                    <CheckboxGroup
                        name="tipo_ufficio_1"
                        options={Object.values(DestinationOfficesType).splice(4, 4)}
                        selectedValues={selectedOffices}
                        onChange={handleTypesChange}
                        optionLabels={{
                            [DestinationOfficesType.UFFICIO_CERT]: "Ufficio certificazione",
                            [DestinationOfficesType.UFFICIO_CONTR]: "Ufficio Controllo",
                            [DestinationOfficesType.UFFICIO_SEGR_TEC]: "Ufficio Segreteria Tecnica",
                            [DestinationOfficesType.UFFICIO_CONT_AMM]: "Ufficio Contabile Amministrativo"
                        }}
                    />
                    <CheckboxGroup
                        name="tipo_ufficio_2"
                        options={Object.values(DestinationOfficesType).splice(8, 4)}
                        selectedValues={selectedOffices}
                        onChange={handleTypesChange}
                        optionLabels={{
                            [DestinationOfficesType.SOT_IS]: "S.O.T. IS",
                            [DestinationOfficesType.SOT_PU]: "S.O.T. PU",
                            [DestinationOfficesType.SOT_BA]: "S.O.T. BA",
                            [DestinationOfficesType.SOT_CL]: "S.O.T. CL"
                        }}
                    />
                </div>



            </div>
            {
                showPopup && (
                    <PopupForm title='Aggiungi Oggetto' close={() => {
                        dispatch(resetEPObjCreationRequest())
                        setShowPopup(false)
                    }}>
                        <AddObjectPopupEntry close={() => {
                            dispatch(resetEPObjCreationRequest())
                            setShowPopup(false)
                        }} />
                    </PopupForm>
                )
            }
        </div>
    )
}